<template>
    <div class="feed-video-list">
        <ul class="video-ul" data-spm="fd-d">
            <li data-spm-type='resource' class="video-item" v-for="(item, index) in dataList"  :data-spm-content="spmContent(item)" :key="item.id">
                <div class="video-box" :style="`height: ${item.height}px`" @click="playVideo(index)">
                    <h4 class="video-title">{{item.title}}</h4>
                    <img :class="['video-cover', item.isVertical && 'vertical']" :src="item.cover" alt="" />
                    <i class="video-play-btn"></i>
                    <span class="video-info">{{item.total}}</span>
                </div>
                <div class="video-footer">
                    <a class="author" :href="item.authorHomePage">
                        <div class="img-box">
                            <img :src="item.authorCover" alt="" />
                        </div>
                        <span class="author-name">{{item.authorName}}</span>
                    </a>
                    <a class="entry-a" :href="item.url" data-spm-type='content'>
                        <div class="comment-icon" @click.prevent="goCommentPage(item.id, item.authorId)">
                            <span class="count" v-if="item.comments">{{item.comments}}</span>
                        </div>
                    </a>
                </div>
            </li>
        </ul>
        <div class="recommend-entry">
            <div class="recommend-entry-btn" @click.stop="gotoChannel()" data-spm="enter-dsp">
                <span>查看更多精彩内容</span>
                <i class="icon icon-entry-right"></i>
            </div>
        </div>
    </div>
</template>
<script>
import Util from '../utils/util'
import PicUtils from '../utils/pic-util';
import { getOdinData } from '@/js/request/odinRequest'
import { getOdinResourceIdMap } from "@/config/odinResourceIds"

export default {
    name: 'feedVideoList',
        props:{
        //文章ID
        articleId: {
            type: [ Number, String ],
            default: 0,
        },
        //feed流每次加载的数目
        size: {
            type: [ Number, String ],
            default: 20,
        },
        /**
         * @description 文章所述频道id
         */
        channelId: {
            type: String,
            default: 0,
        },

    },
    data () {
        return {
            maxHeight: 800,
            dataList: [],
        }
    },
    mounted () {
        this.init()
    },
    methods: {
        init () {
            this.getData()
        },
        goCommentPage(id, authorId) {
            if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                window.sohuSpm.sendAction({
                    acode: '8883',
                });
            }
            window.location.href = `/cm/${id}_${authorId}`
        },
        async getData () {
            const spmObj = window?.sohuSpm?.getCodes()
            const idsMap = getOdinResourceIdMap('videoArticleRecommend')
            const params = {
                tplCompKey:'videoArticleRecommend',
                adInfo: idsMap.adInfo,
                spmCCode: idsMap.spmCCode,
                resourceId: idsMap.resourceId,
                content: {
                    page: 1,
                    size: this.size,
                    productId: idsMap.productId,
                    productType: idsMap.productType,
                    spm: `${spmObj?.a}.${spmObj?.b}.${idsMap?.spmCCode}`
                },
                context: { 
                    mkey: `channelId_${this.channelId}--mpid_${this.articleId}`
                }
            }
            let res = await getOdinData(params)
            if(res?.list?.length) {
                const list = res.list
                Util.eventBus.$emit('videoFeedLoadData', list)
                this.dataList = this.setVideoInfo(list)
                this.$nextTick(() => {
                    if (window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function') {
                        window.sohuSpm.domDidChange({ target: 'fd-d'});
                    }
                })
            }
        },
        // 设置视频的宽高
        setVideoInfo (videos) {
            if(!videos || !Array.isArray(videos)) return
            videos.forEach(video => {
                const width = video.videoWidth
                const height = video.videoHeight
                var cover = video.cover && video.cover[0]
                // 若cover中带有'w_228和h_148'，手动扩大2倍，不然会失真，g_face也去掉
                if(cover) {
                    cover = cover.replace('w_228','w_456').replace('h_148','h_296').replace(/,g_faces*/,'')
                }
                const picObj = PicUtils.setVideoPicUtil({
                    width: width,
                    height: height,
                    cover: cover,
                })
                video.isVertical = height > width
                video.height = picObj.height
                video.cover = picObj.cover
                // 兼容老的数据结构
                video.videoInfo = {
                    videoUrl: video.videoUrl,
                    height: height,
                    width: width,
                    cover,
                }
            })
            return videos
        },
        playVideo (index) {
            Util.eventBus.$emit('videoFeedClick', index);
        },
        spmContent (item) {
            return Util.getSpmContent(item)
        },
        gotoChannel() {
            window.location.href = '//m.sohu.com/v'
        }
    }
}
</script>
<style lang="less" scoped>
@import '../less/base/mixins';
// 视频落地页相关推荐信息流
.feed-video-list {
    margin-top: 24px;
    .video-item {
        border-bottom: 16px #F8F8F8 solid;
        &:last-child {
            border-bottom: 0;
        }
    }
    .video-box {
        position: relative;
        width: 100%;
        max-height: 800px;
        background: #373737;
        overflow: hidden;
        .video-cover {
            width: 100%;
            min-height: 100%;
            object-fit: cover;
        }

        .vertical {
            width: unset;
            margin: auto;
        }

        .video-info {
            padding: 12px 16px;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 21px;
            position: absolute;
            right: 24px;
            bottom: 16px;
            font-size: 22px;  /* px */
            color: #ffffff;
        }
    }


    .video-title {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        background-image: linear-gradient(0deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.80) 100%);
        box-sizing: border-box;
        padding: 24px 30px;
        line-height: 1.2;
        text-align: justify;
        font-size: 34px; /* px */
        color: #ffffff;
        font-weight: bold;
        overflow: hidden;
        .line-clamp();
    }

    // 视频item footer信息
    .video-footer {
        display: flex;
        font-size: 28px; /* px */
        color: #A4A4A4;
        .author {
            display: flex;
            padding: 20px 30px;
            align-items: center;
            .img-box {
                width: 40px;
                height: 40px;
                border-radius: 20px;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .author-name {
                padding-left: 18px;
                color: #A4A4A4;
            }
        }
        .entry-a {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding: 20px 60px 20px 30px;
            .comment-icon {
                width: 40px;/*px*/
                height: 40px;/*px*/
                background: url('../less/images/comment.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                position: relative;
                .count {
                    position: absolute;
                    top: -12px;/*px*/
                    right: -12px;/*px*/
                    width: 28px;/*px*/
                    height: 28px;/*px*/
                    border-radius: 50%;
                    border: 2px solid #fff;/*px*/
                    background: #FFD100;
                    color: #111;
                    font-size: 24px;/*px*/
                    text-align: center;
                    line-height: 28px;/*px*/
                }
            }
            .icon-ic-list-comment {
                position: relative;
                top: 6px;
                color: #A4A4A4;
                font-size: 32px;
            }
        }
    }

    .recommend-info {
       text-align: center;
       color: #999999;
    }
    .recommend-entry {
        padding-top: 20px;
        text-align: center;
        color: #656565;
        &-btn {
            display: inline-flex;
            align-items: center;
            padding: 24px 40px;
            border-radius: 44px;
            font-size: 30px;
            font-weight: 500;
            background: #F5F5F5;
            .icon-entry-right {
                margin-left: 9px;
                font-weight: bold;
                font-size: 22px;
            }
        }
    }
}

</style>
